// extracted by mini-css-extract-plugin
export default {"main":"DashboardLayout_main__ZO-CW"};